import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'resource#title_graffito',
  type: 'graffito',
  tabs: 'graffito',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'editor_metadata',
        type: 'metadata',
      },
      {
        id: 'image-viewer-iiif',
        type: 'viewer-iiif',
        title: 'resource#image-viewer-iiif',
        options: {
          libOptions: {
            window: {
              sideBarOpenByDefault: false,
              allowClose: false,
              allowMaximize: true,
              defaultSideBarPanel: 'info',
              views: [
                { key: 'single' },
                { key: 'gallery' },
              ],
              workspaceControlPanel: {
                enabled: false,
              },
            },
            id: 'mirador-container',
          },
        }
      },
      {
        id: 'text-viewer-graffito_text',
        type: 'text-viewer',
        options: {
          searchId: 'xml_text',
        },
      },
      {
        id: 'tab-bar',
        type: 'tabs',
      },
    ],
    content: [
      {
        id: 'metadata-graffito_observation',
        type: 'metadata',
        // title: 'resource#metadata_graffito_biblio',
      },
    ],
  },
} as ConfigMurucaResourceLayout;